import React from 'react';
import { observable, action, runInAction, toJS } from 'mobx';
import { observer } from 'mobx-react';

import { Row, Col, Input, Card, Icon, Modal, Button, Form, Upload, Avatar, Select, message } from 'antd';
import user_bet_record_store from '@store/User/UserList/UserBetRecordStore.js'; 
import agent_detail_pay_store from '@store/Agent/AgentDetailPayStore';
import user_store, { pagination_store, filter_store } from '@store/User/UserList/UserStore';

const CardMeta = Card.Meta;
@observer
class UserInfo extends React.Component {
  constructor() {
    super();
  }

  render() {
    return (
      <Row>
        <Col span={12}>
          <CardMeta
            title={(
              <div>
                <span>会员{user_bet_record_store.pet_name}  </span>
                <span>
                  <Button size="small" onClick={() => {
                    agent_detail_pay_store.openModal(user_bet_record_store,
                      (item)=>{
                        user_bet_record_store.updateRecord(item);
                        // 重新拉取数据，刷新列表
                        user_store.searchByFilter();
                      });
                  }}>代充</Button>
                </span>
              </div>
            )}
            description={(
              <div>
                <span style={{
                  marginRight: '30px'
                }}>{user_bet_record_store.nick_name}</span>
                <span style={{
                  marginRight: '30px'
                }}>
                  <span>账户余额：</span>
                  <span>￥{user_bet_record_store.balance}</span>
                </span>
                <span style={{
                  marginRight: '30px'
                }}>
                  <span>下线会员：</span>
                  <span>{user_bet_record_store.user_num}</span>
                </span>
              </div>
            )}
            avatar={
              <Avatar />
            }/>
        </Col>
      </Row>
    );
  }

  componentDidMount() {
  }
}

export default UserInfo;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/User/UserList/UserBetRecord/UserInfo.jsx